import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import { inject, observer } from 'mobx-react'
import Pagination from 'react-js-pagination'
import { Img } from 'react-image'
import { IoIosHelpCircleOutline } from 'react-icons/io'
import { BsTrash } from 'react-icons/bs'
import { currencyN } from '../utils'
import classNames from 'classnames'
import styled from 'styled-components'

@inject('store')
@observer
class AdminDataTable extends React.Component {
  static propTypes = {
    store: PropTypes.object,
    data_table: PropTypes.object,
    totalItemsCount: PropTypes.number,
    dataTableChanged: PropTypes.func,
    handlePaginatorChange: PropTypes.func,
    handlePageSizeChange: PropTypes.func,
    // handleSortChange: PropTypes.func,
    handlePermissionsChange: PropTypes.func,
    handlePageChange: PropTypes.func,
    active_page: PropTypes.number,
    currentDisplay: PropTypes.func,
    table_class: PropTypes.string,
    select_class: PropTypes.string,
    organization: PropTypes.bool,
    show_confirm_remove: PropTypes.func,
    dashboard: PropTypes.bool,
    getModalContent: PropTypes.func,
    small_labels: PropTypes.bool
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let { activePage } = this.props.data_table
    if (
      this.props.data_table &&
      this.props.data_table.data &&
      this.props.data_table.data.length === 1 &&
      activePage > 1
    ) {
      activePage = Number(activePage) - 1
    }
    const data = this.props.data_table.data
    const sortColumn = {}
    const coln = { label: '', sortType: '' }
    for (const key in this.props.data_table.fields) {
      sortColumn[key] = coln
      sortColumn[key].label = this.props.data_table.fields[key]
      sortColumn[key]['sortType'] = ''
    }
    this.props.data_table.filteredData = data
    this.props.data_table.sortColumn = sortColumn
    this.props.data_table.activePage = activePage
    this.forceUpdate()
  }

  //  onClick={() => this.sortData(key)}
  sortData(key) {
    //   this.props.handleSortChange(key)
  }

  getTableHeader() {
    const list = []
    for (const key in this.props.data_table.fields) {
      const value = this.props.data_table.fields[key]
      list.push(
        <th key={'thred-' + key} onClick={() => this.sortData(key)}>
          {value}
        </th>
      )
    }
    return <tr>{list}</tr>
  }

  getTableBody() {
    if (
      !this.props.data_table.filteredData ||
      this.props.data_table.filteredData.length === 0
    ) {
      return (
        <tr>
          <td className="text-center" colSpan={this.props.data_table.colLength}>
            No Data Found
          </td>
        </tr>
      )
    }
    return this.props.data_table.filteredData.map((item, i) => {
      const rows = []
      for (const key in this.props.data_table.fields) {
        if (
          [
            'organization_admin',
            'can_access_billing',
            'can_request_consultation'
          ].includes(key)
        ) {
          rows.push(
            <td key={'tbody-row-' + i + '-col-' + key}>
              <select
                id={key}
                className={
                  'form-control form-control-sm ' + this.props.select_class
                }
                onChange={(e) => {
                  this.props.handlePermissionsChange(
                    i,
                    this.props.data_table.data[i].id,
                    this.props.data_table.data[i].name,
                    e.target.id,
                    e.target.value
                  )
                }}
                value={item[key]}
              >
                <option key={true} value={true}>
                  Yes
                </option>
                <option key={false} value={false}>
                  No
                </option>
              </select>
            </td>
          )
        } else if (this.props.organization && key === 'delete') {
          if (
            this.props.data_table.data[i].email !==
            this.props.store.sessionData.userData.email
          ) {
            rows.push(
              <td key={'tbody-row-' + i + '-col-delete'}>
                <div
                  className="action-btn-danger clickable in-table trash-icon-button"
                  onClick={() => {
                    this.props.show_confirm_remove(
                      this.props.data_table.data[i].email,
                      this.props.data_table.data[i].name
                    )
                  }}
                >
                  <BsTrash />
                </div>
              </td>
            )
          } else {
            rows.push(<td key={'tbody-row-' + i + '-col-delete'}></td>)
          }
        } else if (this.props.organization && key === 'img') {
          rows.push(
            <td key={'tbody-row-' + i + '-col-delete' + key}>
              <div className="orgProfileImg">
                <Img src={[item[key], '/assets/images/no-image.jpg']} />
              </div>
            </td>
          )
        } else if (this.props.dashboard && key === 'display_status') {
          rows.push(
            <td key={'tbody-row-' + i + '-col-' + key} className="">
              {item[key]}{' '}
              <IoIosHelpCircleOutline
                onClick={() => {
                  this.props.getModalContent(item)
                }}
                className={
                  'clickable dahsboard-icon ' +
                  classNames({
                    'display-none': item[key] !== 'Awaiting your response'
                  })
                }
              />
            </td>
          )
        } else if (this.props.dashboard && key === 'savings') {
          rows.push(
            <td key={'tbody-row-' + i + '-col-' + key} className="">
              {item[key] ? currencyN(item[key]) : ''}
            </td>
          )
        } else {
          const value = item[key]
          rows.push(<td key={'tbody-row-' + i + '-col-' + key}>{value}</td>)
        }
      }
      return <tr key={'tbody-row-' + i}>{rows}</tr>
    })
  }

  render() {
    const active_page =
      this.props.data_table && this.props.data_table.activePage
        ? this.props.data_table.activePage
        : this.props.active_page
    return (
      <>
        <div
          className="table-responsive admin-table-responsive"
          style={{ margin: '10px 0' }}
        >
          <table className="table admin-table">
            <thead
              className={
                'bg-primary text-white text-nowrap ' +
                classNames({ 'small-labels': this.props.small_labels })
              }
            >
              {this.getTableHeader()}
            </thead>
            <tbody className={this.props.table_class}>
              {this.getTableBody()}
            </tbody>
          </table>
        </div>
        {!this.props.organization && (
          <TableFooter style={{ flex: '0 1 auto' }}>
            <PaginationWrapper>
              <Pagination
                activePage={active_page}
                itemsCountPerPage={this.props.data_table.perPage}
                totalItemsCount={this.props.totalItemsCount}
                pageRangeDisplayed={this.props.data_table.pageRangeDisplayed}
                onChange={this.props.handlePageChange}
                prevPageText={'Prev'}
                nextPageText={'Next'}
                firstPageText={'First'}
                lastPageText={'Last'}
              />
            </PaginationWrapper>
            <div className="form-inline" style={{ padding: '10px' }}>
              Page: {this.props.currentDisplay()}
            </div>
            <div className="form-inline">
              <label className="chalice-label">Page size: &nbsp; </label>
              <select
                className="form-control form-control-sm"
                onChange={(e) =>
                  this.props.handlePageSizeChange(e.target.value)
                }
                value={this.props.data_table.perPage}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </select>
            </div>
          </TableFooter>
        )}
      </>
    )
  }
}

export default withRouter(AdminDataTable)

export const TableFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${(props) => props.theme.media.phone`
    flex-direction: column;
    text-align: center;
  `}
`

export const PaginationWrapper = styled.div`
  ul {
    display: inline-block;
    padding-left: 0;
    margin: 0;
    border-radius: 4px;
  }
  li {
    display: inline;
  }
  .disabled > a,
  .disabled > span {
    color: #777;
    cursor: not-allowed;
    background-color: #fff;
    border-color: #ddd;
    line-height: 1.42857143;
  }
  a,
  span {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
  }
`
